var $6ee4da2747de1e02$exports = {};
$6ee4da2747de1e02$exports = {
    "loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "loadingMore": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43E}\u{449}\u{435}...`
};


export {$6ee4da2747de1e02$exports as default};
//# sourceMappingURL=bg-BG.module.js.map
